/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ActorDefs from "./defs.defs.js";

const $nsid = "app.bsky.actor.getProfile";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"actor":/*#__PURE__*/ l.string({"format":"at-identifier"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("application/json", /*#__PURE__*/ l.ref<ActorDefs.ProfileViewDetailed>((() => ActorDefs.profileViewDetailed) as any));

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get detailed profile view of an actor. Does not require auth, but contains relevant metadata with auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
